// - Logic of image naming should be:
//     - parkplatz_{parkinglotname}_{city}_01
//     - parkplatz_{parkinglotname}_{city}_02
//     - parkplatz_{parkinglotname}_{city}_03
import { GalleryImage } from '@components/ImagesGallery/ImagesGallery.component'
import { TFunction } from 'i18next'

// galleryImage = src, alt
export const parseLotImages = (images: string[], lotName: string, city: string, t: TFunction): GalleryImage[] => {
    if (!images || !images.length) return []

    return images.map((image, index) => ({
        src: image,
        alt: `${t('seo.lot.imageDescription', {
            name: lotName,
            city
        })}_0${index + 1}`
    }))
}
